// extracted by extract-css-chunks-webpack-plugin
module.exports = {"label":"QoSc9","deleteButton":"MfU0X"};